/**
 * Determines if the current player path is for a trailer
 *
 * @param {string} path The current path
 */
export const isPathTrailer = path => {
  return /\/trailer\//.test(path)
}
